module.exports = __webpack_public_path__ + "img/course_008.6910ad9.webp";